import { Navigate } from "react-router-dom";
import { useAuth } from "./index";

export const Login = () => {
  const { authService } = useAuth();
  const login = async () => {
    authService.authorise();
  }
  
  if (!authService.isAuthenticated()) {
    login();
 }
 else
 {
   return <Navigate to="/" replace={true}></Navigate>
 }
 return <></>;
}

